import { render, staticRenderFns } from "./PracticeAdminCard.vue?vue&type=template&id=78878a76"
import script from "./PracticeAdminCard.vue?vue&type=script&lang=js"
export * from "./PracticeAdminCard.vue?vue&type=script&lang=js"
import style0 from "./PracticeAdminCard.vue?vue&type=style&index=0&id=78878a76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports